import { useEffect, useRef, useState } from 'react';
import "react-datepicker/dist/react-datepicker.css";
import { useDispatch } from 'react-redux';
import { setSubLoading } from '../../Redux/Services/AuthSlice';
import { NotificationSound } from '../CommonComponents/CommonNotification';
import { ApiCall, DropDownData, convertToNumber, deleteData, initializeFilterData } from '../CommonComponents/CustomHooks';
import { CommonApiData } from '../CommonComponents/EnvConfig';
import { BulkClearData, DownloadFileAtURL, ERRORDATALIST, HandleBulkInsertData, handleDownloadExcel, readFile } from '../CommonComponents/ExportData';
import { FormButton, ImportButton, InputBox, SelectInputBox, Switch } from '../CommonComponents/InputBox';
import { Table } from '../CommonComponents/Table';

const DealerMaster = () => {
    const inputrefs = useRef([])
    const dispatch = useDispatch();
    const [isLoading, setIsLoading] = useState(false);
    const [tableData, setTableData] = useState([])
    const GeDealerType = DropDownData('GetDealerTypeMaster')
    const [Name, setName] = useState('');
    const [currentPageNo, setCurrentPageNo] = useState(1);
    const [filterData, setFilterData] = useState(initializeFilterData)
    const [sortConfig, setSortConfig] = useState({ SortColumn: null, SortOrder: null });
    const [Status, setStatus] = useState([])
    const [ImportData, setImportData] = useState([])
    const [formData, setFormData] = useState({
        dealerID: '',
        dealerCode: '',
        dealerName: '',
        dealerName: '',
        password: 'Sipl@123',
        dealerType: '',
        address: '',
        mobileNo: '',
        emailID: '',
        pincodeNo: '',
        cityName: '',
        stateName: '',
        isActive: true,
        isMain: false,
        paymentByCustomer: true,
    });

    const getDealerMasterData = async (CurrentPage) => {
        let PageIndex = 1
        if (CurrentPage !== undefined && typeof (CurrentPage) !== "object") {
            PageIndex = CurrentPage;
            setCurrentPageNo(CurrentPage);
        }
        else {
            setCurrentPageNo(1);
        }
        const data = {
            ...filterData,
            Type: 'S',
            PageIndex: `${PageIndex}`,
            ...sortConfig,
        }
        setIsLoading(true)
        let res = await ApiCall(`/api/DealerMaster/ShowDealerMaster`, data)
        if (res.Status === "SUCCESS") {
            setTableData(res)
        }
        if (res.Status === "ERROR") {
            setTableData([])
        }
        setIsLoading(false)
        if (res.Status === 'EXPIRED') {
            await NotificationSound(res.Status, res.Message, res.focus, inputrefs);
        }
    }

    const handleClear = async () => {
        setFormData({
            dealerID: '',
            dealerCode: '',
            dealerName: '',
            dealerType: '',
            password: 'Sipl@123',
            groupName: '',
            address: '',
            mobileNo: '',
            emailID: '',
            pincodeNo: '',
            cityName: '',
            stateName: '',
            isActive: true,
            isMain: false,
            paymentByCustomer: true,
        });
        await setImportData([])
        await BulkClearData(setName)
        await setName('')
        await setStatus([])
        filterData.SearchText = '';
        getDealerMasterData();
    }

    const handleSubmit = async () => {
        await dispatch(setSubLoading(true))
        let data = await ApiCall(`/api/DealerMaster/InsertUpdateDealerMaster`, { ...formData })
        await dispatch(setSubLoading(false))
        await NotificationSound(data.status, data.message, data.focus, inputrefs, handleClear);
    };

    const handleEditData = async (id) => {
        await dispatch(setSubLoading(true))
        let editData = await ApiCall(`/api/DealerMaster/EditDealerMaster`, { dealerID: id })
        await dispatch(setSubLoading(false))
        if (editData.status === 'UNAUTHORIZED' || editData.status === 'ERROR' || editData.status === 'EXPIRED') {
            await NotificationSound(editData.status, editData.message, editData.focus, inputrefs);
        }
        else if (editData.status === 'SUCCESS') {
            let record = editData
            setFormData((pre) => ({
                ...pre, ...record
            }))
        }
    }

    const handleDelete = async (id) => {
        await dispatch(setSubLoading(true))
        await deleteData(`/api/DealerMaster/DeleteDealerMaster`, { dealerID: id }, getDealerMasterData, handleClear, '', inputrefs)
        await dispatch(setSubLoading(false))
    }
    const handleChange1 = (event, value) => {
        getDealerMasterData(value);
    };
    const DownloadFormat = async () => {
        await DownloadFileAtURL('DealerMaster.xlsx')
    };

    const ErrorData = async () => {
        await ERRORDATALIST(Status, 'DealerMasterError')
    }

    const BulkSubmit = async (e) => {
        await dispatch(setSubLoading(true))
        let data = await readFile(e)
        setImportData(data.exceljson)
        setName(data.FileName)
        await dispatch(setSubLoading(false))
    };

    const handleBulk = async () => {
        const Data2 = {
            "authToken": CommonApiData().AuthToken,
            "loginToken": CommonApiData().LoginToken,
            "loginUserCode": CommonApiData().UserCode,
            "companyCode": CommonApiData().CompanyCode,
            dealerCode: '',
            password: 'Sipl@123'

        };
        if (ImportData.length !== 0) {
            if ((Object.keys(ImportData[0])).includes("dealerCode", "dealerName", "dealerType", "address", "mobileNo", "emailID", "pincodeNo", "cityName", "stateName", "isActive", "isMain", "paymentByCustomer")) {
                await dispatch(setSubLoading(true))
                let Data = await HandleBulkInsertData('/api/DealerMaster/InsertUpdateDealerMaster', ImportData, Data2, getDealerMasterData)
                await setStatus(Data)
                await dispatch(setSubLoading(false))
                await NotificationSound('INFO', `Success : ${Data.SuccessCount} Error : ${Data.ErrorCount}`);
                BulkClearData(setName)

            } else {
                await NotificationSound('ERROR', 'Header Format is not valid !');
                BulkClearData(setName)
            }
        } else {
            await NotificationSound('ERROR', 'Please Choose File With Valid Data.!');
            BulkClearData(setName)
        }
    }
    const handleSorting = (SortColumn) => {
        let SortOrder = 'ASC';
        if (sortConfig && sortConfig.SortColumn === SortColumn && sortConfig.SortOrder === 'ASC') {
            SortOrder = 'DESC';
        }
        setSortConfig({ SortColumn, SortOrder });
    };
    useEffect(() => {
        getDealerMasterData()
        document.title = 'Dealer Master'
        inputrefs.current['txtDealerCode'].focus()
    }, [sortConfig])

    return (
        <>
            <div className='main-card card border-0'>
                <div className='pt-1 row px-3 border-0'>
                    <div className='card-header mb-1'>
                        <h6 className="m-0">  {'Dealer Master'} </h6>
                    </div>
                    <div className='card-body pb-1 row'>
                        <div className='col-md-6 col-lg-8'>
                            <div className='row'>
                                <InputBox
                                    id="txtDealerCode"
                                    type="text"
                                    required={true}
                                    label='Dealer Code'
                                    divclassname="col-lg-3 col-md-6 col-sm-12 mb-1"
                                    maxLength='40'
                                    inputrefs={inputrefs}
                                    placeholder='Dealer Code'
                                    name='DealerCode'
                                    value={formData.dealerCode}
                                    onChange={(e) => setFormData({ ...formData, dealerCode: e.target.value })}
                                    onKeyDown={(e) => {
                                        if (e.key === 'Enter') {
                                            inputrefs.current['txtDealerName'].focus()
                                        }
                                    }}
                                />
                                <InputBox
                                    id="txtDealerName"
                                    type="text"
                                    label='Dealer Name'
                                    required={true}
                                    placeholder="Dealer Name"
                                    divclassname="col-lg-3 col-md-6 col-sm-12 mb-1"
                                    maxLength='30'
                                    value={formData.dealerName}
                                    onChange={(e) => setFormData({ ...formData, dealerName: e.target.value })}
                                    inputrefs={inputrefs}
                                    onKeyDown={(e) => {
                                        if (e.key === 'Enter') {
                                            inputrefs.current['ddlDealerType'].focus()
                                        }
                                    }}
                                />
                                <InputBox
                                    id="txtPassword"
                                    type="password"
                                    placeholder="Password"
                                    divclassname="col-lg-3 col-md-6 col-sm-12 mb-1 d-none"
                                    label={'Password'}
                                    maxLength="15"
                                    required={true}
                                    value={formData.password}
                                    onChange={(e) => setFormData({ ...formData, password: e.target.value })}
                                    inputrefs={inputrefs}
                                    onKeyDown={(e) => {
                                        if (e.key === 'Enter') {
                                            inputrefs.current['ddlDealerType'].focus()
                                        }
                                    }}
                                />
                                <SelectInputBox
                                    id="ddlDealerType"
                                    value={formData.dealerType}
                                    divclassname="col-lg-3 col-md-6 col-sm-12 mb-1"
                                    label='Dealer Type'
                                    required={true}
                                    onChange={(e) => setFormData({ ...formData, dealerType: e.target.value })}
                                    inputrefs={inputrefs}
                                    onKeyDown={(e) => {
                                        if (e.key === 'Enter') {
                                            inputrefs.current['txtMobileNo'].focus()
                                        }
                                    }}
                                >
                                    <option value=''>--Please Select--</option>
                                    {GeDealerType?.data?.dataList?.map((item, index) =>
                                        <option key={item.name + index} value={item.code}>{item.name}</option>
                                    )}
                                </SelectInputBox>

                                <InputBox
                                    id="txtMobileNo"
                                    placeholder="Mobile Number"
                                    autoComplete="off"
                                    maxLength='15'
                                    divclassname="col-lg-3 col-md-6 col-sm-12 mb-1"
                                    label='Mobile No'
                                    value={formData.mobileNo}
                                    onChange={(e) => setFormData({ ...formData, mobileNo: convertToNumber(e.target.value) })}
                                    inputrefs={inputrefs}
                                    onKeyDown={(e) => {
                                        if (e.key === 'Enter') {
                                            inputrefs.current['txtEmailID'].focus()
                                        }
                                    }}
                                />
                                <InputBox
                                    type="email"
                                    id="txtEmailID"
                                    label='Email ID'
                                   
                                    divclassname="col-lg-3 col-md-6 col-sm-12 mb-1"
                                    placeholder="Email ID"
                                    maxLength='50'
                                    name='EmailId'
                                    value={formData.emailID}
                                    onChange={(e) => setFormData({ ...formData, emailID: e.target.value })}
                                    inputrefs={inputrefs}
                                    onKeyDown={(e) => {
                                        if (e.key === 'Enter') {
                                            inputrefs.current['txtPinCode'].focus()
                                        }
                                    }}
                                />

                                <InputBox
                                    type="text"
                                    id="txtPinCode"
                                    className="form-control"
                                    placeholder="Pin Code"
                                    divclassname="col-lg-3 col-md-6 col-sm-12 mb-1"
                                    label='Pin Code'
                                    maxLength='6'
                                    value={formData.pincodeNo}
                                    onChange={(e) => setFormData({ ...formData, pincodeNo: convertToNumber(e.target.value) })}
                                    inputrefs={inputrefs}
                                    onKeyDown={(e) => {
                                        if (e.key === 'Enter') {
                                            inputrefs.current['txtState'].focus()
                                        }
                                    }}
                                />
                                <InputBox
                                    type="text"
                                    id="txtState"
                                    className="form-control"
                                    placeholder="State"
                                    divclassname="col-lg-3 col-md-6 col-sm-12 mb-1"
                                    label='State'
                                    maxLength='15'
                                    value={formData.stateName}
                                    onChange={(e) => setFormData({ ...formData, stateName: e.target.value })}
                                    inputrefs={inputrefs}
                                    onKeyDown={(e) => {
                                        if (e.key === 'Enter') {
                                            inputrefs.current['txtCity'].focus()
                                        }
                                    }}
                                />
                                <InputBox
                                    type="text"
                                    id="txtCity"
                                    className="form-control"
                                    divclassname="col-lg-3 col-md-6 col-sm-12 mb-1"
                                    placeholder="City"
                                    label='City'
                                    maxLength='15'
                                    value={formData.cityName}
                                    onChange={(e) => setFormData({ ...formData, cityName: e.target.value })}
                                    inputrefs={inputrefs}
                                    onKeyDown={(e) => {
                                        if (e.key === 'Enter') {
                                            inputrefs.current['txtAddress'].focus()
                                        }
                                    }}
                                />
                                <div className="col-lg-9 col-md-9 col-sm-12 ">
                                    <label style={{ 'whiteSpace': 'nowrap' }} className="form-label" >Address</label>
                                    <textarea
                                        id="txtAddress"
                                        ref={ref => (inputrefs.current["txtAddress"] = ref)}
                                        className="col-lg-6 col-md-6 col-sm-12 form-control"
                                        placeholder="Address...."
                                        cols={500}
                                        value={formData.address}
                                        onChange={(e) => setFormData({ ...formData, address: e.target.value })}
                                    />
                                </div>
                                <Switch
                                    inputrefs={inputrefs}
                                    label='Is Main'
                                    checked={formData.isMain}
                                    divclassname="col-lg-2 col-md-2 me-4"
                                    id='txtIsMain'
                                    onKeyDown={(e) => {
                                        if (e.key === 'Enter') {
                                            inputrefs.current['txtPaymentByCustomer'].focus()
                                        };
                                    }}
                                    onChange={(e) => setFormData({ ...formData, isMain: e.target.checked })}
                                />
                                <Switch
                                    inputrefs={inputrefs}
                                    label='Only Payment By Customer'
                                    checked={formData.paymentByCustomer}
                                    divclassname="col-lg-3 col-md-3 me-4"
                                    id='txtPaymentByCustomer'
                                    onKeyDown={(e) => {
                                        if (e.key === 'Enter') {
                                            inputrefs.current['txtActive'].focus()
                                        };
                                    }}
                                    onChange={(e) => setFormData({ ...formData, paymentByCustomer: e.target.checked })}
                                />
                                <Switch
                                    inputrefs={inputrefs}
                                    label='Active'
                                    checked={formData.isActive}
                                    divclassname="col-lg-3 col-md-3 me-4"
                                    id='txtActive'
                                    onKeyDown={(e) => {
                                        if (e.key === 'Enter') {
                                            inputrefs.current['btnSub'].focus()
                                        };
                                    }}
                                    onChange={(e) => setFormData({ ...formData, isActive: e.target.checked })}
                                />
                            </div>
                        </div>
                        <div className='d-flex col-md-6 col-lg-4 h-65 mb-2'>
                            <ImportButton
                                handleBulk={handleBulk}
                                BulkSubmit={(e) => BulkSubmit(e)}
                                downloadFormat={DownloadFormat}
                                ErrorData={ErrorData}
                                Status={Status}
                                HeaderFormat="PayMode, Active"
                                fileName={Name}
                            >
                            </ImportButton>
                        </div>
                        <div className='card-body'>
                            <FormButton
                                id={'btnSub'}
                                inputrefs={inputrefs}
                                handleSubmit={handleSubmit}
                                handleExport={() => handleDownloadExcel(`/api/DealerMaster/ShowDealerMaster`, filterData, 'Dealer Master')}
                                handleClear={handleClear}
                            />
                        </div>
                    </div>
                </div>
            </div>
            <Table
                handleEdit={handleEditData}
                handleDelete={handleDelete}
                loading={isLoading}
                PageName={'DealerMaster'}
                handleFilter={() => {
                    getDealerMasterData()
                    setFilterData({
                        ...filterData,
                    })
                }}
                filterData={filterData}
                tableData={tableData}
                setFilterData={setFilterData}
                currentPageNo={currentPageNo}
                handleChange1={handleChange1}
                handleSorting={handleSorting}
                sortConfig={sortConfig}
            />
        </>
    )
}
export default DealerMaster;